
// @flow
import React, {memo, useEffect, useState} from 'react';
import {Swipe} from "mirsahib-react-swipe-component";
import {randomIdentifier} from "../../../utils/helpers";



type Props = {
    id: String,
    children: any,
    type: String,
    show: boolean,
    swipeDown: boolean,
    heading: boolean,
    closeButton: boolean,
    overlay: boolean,
    title: String,
    style: Object,
    handleClose: any
};

const ModalComponent = ({
    id,
                        type,
    show,
                            children,
    swipeDown,
                            heading,
                            closeButton,
                            title,
                            style,
    handleClose,
    overlay,
                            dataValueModal3 = 0,
                            refreshBarcode,
                            logo ='',
    iconClose = '/images/icon_close_white.svg'
                       }: Props) => {

    const [isShow, setIsShow] = useState(show)
    const [modalY, setModalY] = useState(0)

    useEffect(() => {
        setIsShow(show);
        setModalY(0)
    }, [show])

    const _handleClose = () => {
        setIsShow(false)
        if(typeof handleClose == 'function') handleClose(id, isShow)
    }
    const _refreshBarcode = () => {
        if(typeof refreshBarcode == 'function') refreshBarcode()
    }

    const onSwipeEnd = () => {
        // console.log("Swipe Ended")
        _handleClose()
    }
    const onSwipeLeftListener = () => {
        // console.log("Swiped left")
    }
    const onSwipeRightListener = () => {
        // console.log("Swiped right")
    }
    const onSwipeUpListener = () => {
        // console.log("Swiped Up")
    }
    const onSwipeDownListener = () => {
        // console.log("Swiped down")
    }
    const onSwipeListener = (p) => {
        if (p.x !== 0) {
            // console.log(`Swipe x: ${p.x}`)
        }
        if (p.y !== 0) {
            setModalY(modalY+p.y)
            // console.log(`Swipe y: ${p.y}`)
        }
    }

    return (

        <>

                {overlay && <div id={"cs-modal-overlay-"+id} className={"cs-modal-overlay" + (isShow ? " show" : "")}></div>}
                <div style={{transform: `translateY(${modalY}px)`}} id={"cs-modal-"+id} className={"cs-modal" + (isShow ? " show" : "")}>
                    <div className="cs-modal-container">
                        {swipeDown &&
                        <Swipe
                            nodeName="div"
                            className="test"
                            detectTouch={true}
                            detectMouse={false}
                            onSwipeEnd={onSwipeEnd}
                            onSwipedLeft={onSwipeLeftListener}
                            onSwipedRight={onSwipeRightListener}
                            // onSwipedDown={onSwipeDownListener}
                            onSwipedUp={onSwipeUpListener}
                            onSwipe={onSwipeListener}>
                            <div className="cs-modal-swiper"></div>
                        </Swipe>
                        }

                            {type == 'style-1' && <>
                                {heading && (<>
                                    <div className="cs-modal-heading style-1">
                                        <span style={{flexBasis: "20%"}}></span>
                                        <h3 style={{flexBasis: "60%"}}>{title}</h3>
                                        <span onClick={_handleClose} style={{flexBasis: "20%", textAlign: "right"}}>
                                            {closeButton && <img src="/images/icon_close_black.svg"/>}
                                        </span>
                                    </div>
                                </>)}
                                <div className="cs-modal-body style-1">
                                    {children}
                                </div>
                            </>
                            }

                        {type == 'style-2' && <>
                            {heading && (<>
                                <div className="cs-modal-heading style-2">
                                    <h3 style={{flexBasis: "80%"}}>{title}</h3>
                                    <span onClick={_handleClose} style={{flexBasis: "20%", textAlign: "right"}}>
                                            {closeButton && <img src="/images/icon_close_white.svg"/>}
                                        </span>
                                </div>
                            </>)}
                            <div className="cs-modal-body style-2">
                                {children}
                            </div>
                        </>
                        }
                        {type == 'style-3' && <>
                            {heading && (<>
                                <div className="cs-modal-heading style-3">
                                    <div className={'box-left-modal-3'}>
                                        <img className={'logo-company'} src={logo} />
                                        <img onClick={_refreshBarcode} className={'refresh-icon'} src={'/images/icon_refresh.svg'} />
                                        <div>
                                            <label className={'m-0 text-label'}>가용포인트</label>
                                            <label className={'m-0 value-point'}>{dataValueModal3}</label>
                                        </div>
                                    </div>
                                    <span onClick={_handleClose} className={'close-modal-3'} style={{flexBasis: "20%", textAlign: "right"}}>
                                            {closeButton && <img src={iconClose} />}
                                        </span>
                                </div>
                            </>)}
                            <div className="cs-modal-body style-2">
                                {children}
                            </div>
                        </>
                        }
                    </div>
                </div>
        </>
    );
};

ModalComponent.defaultProps = {
    id: randomIdentifier(),
    type: 'style-1',
    swipeDown: false,
    show: false,
    heading: false,
    closeButton: false,
    title: false,
    style: {},
    overlay: true
};


export default ModalComponent;
